import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Subject, takeUntil } from 'rxjs';
import { GridColConfig, CustomgridOptions } from 'src/app/core/custom-grid/custom-grid';
import { CustomGridComponent } from 'src/app/core/custom-grid/custom-grid.component';
import { ToastService } from 'src/app/core/toast/toast.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { HubService } from 'src/app/services/web-socket/hub.service';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { BaseResponse } from 'src/app/model/response/base-response';
//import { ContrattiService } from '../../contratti/contratti.service';
import { FieldTypeEnum } from 'src/app/core/dynamic-form/dynamicForm.interface';
import { CustomDropDownListOptions } from 'src/app/core/custom-drop-down-list/customDropDownList.interface';
import { DropdownServiceService } from 'src/app/services/dropdown-service.service';
import { GenericDD } from 'src/app/model/generic-data';

@Component({
  selector: 'app-contratti-grid-test',
  templateUrl: './contratti-grid-test.component.html',
  styleUrls: ['./contratti-grid-test.component.scss']
})
export class ContrattiGridTestComponent {

  @ViewChild(CustomGridComponent) Cgrid: CustomGridComponent | undefined;

  options: GridColConfig[]=[];

  private apiDDCounter = new Subject<number>();

  private changes$ = new Subject<any>();

  apiDDCallCount: number = 0;

  totalRows: number = 0;

  pageSettings: PageSettingsModel = {
    pageSize: 25,
    pageSizes: [25, 50, 100],
    pageCount: 1,
    currentPage: 1,
    totalRecordsCount: 100,
  };
  gridOptions: CustomgridOptions = {
    apiCallurl: '/api/contratti/get/lazy',
    rowsCallurl: '/api/contratti/rows/',
    apiTableName: 'MDServiziPerContratti',
  };

  customDropOptions: CustomDropDownListOptions = {
    fields: { value: 'id', text: 'codice' },
    readonly: false,
    allowFiltering: true,
  };

  // public dataToRemove!:AnagraficheAutomezzi;

  lastSession: boolean = false;
  localStorageName: string = "";

  // tabella
  //public pageSetting: PageSettingsModel;
  dialog: any;

  // unsubscribe subscriptions
  private theEnd$ = new Subject<void>();

  arrayTest : Array<any> = [
    {
      id:1,
      codice:'fdsjklfsdjklf'
    },
    {
      id:2,
      codice:'fdsjkdsdfgjkllfsdjklf'
    },
    {
      id:3,
      codice:'fdsdsdsjklfsdjklf'
    }
]

  idToRemove: number = 0;
  ready: boolean=false;


  constructor(
    private hub: HubService,
    private localstorage: LocalStorageService,
    //private contrattiService: ContrattiService,
    private router: Router,
    private toast: ToastService,
    private DropdownService: DropdownServiceService,
  ) {
    let model: any;

    // get all localstorage value
    /* for ( var i = 0, len = localStorage.length; i < len; ++i ) {

       //console.error( localStorage.getItem( localStorage.key( i ) || "" ) );
       let key = localStorage.key(i);
       if(key?.startsWith("grid")){
         //console.log(localStorage.getItem(key));
         this.localStorageName = key;
         model = JSON.parse(localStorage.getItem(key) || "{object: 'none'}");
       }
     }
     console.warn(model);
     if(model != undefined ) {
       this.pageSetting = model.pageSettings;
       console.log("page from last session");
       this.lastSession = true;
     }else{
       this.pageSetting = {
         pageSizes: [25,50,100],
         pageSize: 25,
         currentPage: 1,
       };
       console.log("new page setting");
     }*/



  }


  getClienteDD() {
    // this.DropdownService.DDTipoContratto().pipe(takeUntil(this.theEnd$)).subscribe({
    //   next: (data: Array<GenericDD>) => {
    //     this.options[3].dropdown= data;
    //     this.apiDDCallCount++;
    //     console.log(this.apiDDCallCount)
    //     this.apiDDCounter.next(1);
    //   },
    //   error: () => {

    //   }
    // });
  }


  ngOnInit(): void { //TODO make lazy loading


    this.localstorage.setTitolo('Contratti')

    this.ready=true;
    this.apiDDCounter.pipe(takeUntil(this.theEnd$)).subscribe(() => {

      console.log(this.apiDDCallCount)
      if (this.apiDDCallCount == 1) {
        this.ready = false;
      }
    });


    this.options =
      [

        {
          type: 'switch',
          name: 'Stato',
          field: 'active',
          width: '40',
          fieldOptions: {

          }
        },
        {
          type: 'text',
          name: 'NR Contratto',
          field: 'nContratto',
          fieldOptions: {

          }
        },
        {
          type: 'dropdown',
          field: 'idCliente',
          name: 'Cliente/Fornitore',
          fieldOptions: {

          },




        },


        {
          type: 'dropdown',
          name: 'Tipo contratto',
          field: 'idDDTipoContratto',
          fieldOptions: {

          },
          // ddO: this.customDropOptions.fields,


        },
        {
          type: 'date',
          name: 'Data stipula',
          field: 'dataStipula',
          fieldOptions: {

          }
        },


        {
          type: 'button',
          name: 'Modifica',
          field: 'none',
          fieldOptions: {
            icon: 'e-edit edit-button',
          },
          width: '40'
        },
        {
          type: 'button',
          name: 'Elimina',
          field: 'none',
          fieldOptions: {
            icon: 'e-delete delete-button',
          },
          width:'40'
        },
      ];


      this.getClienteDD()
  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
    /*this.theEnd$.unsubscribe();*/
  }

  actionBeginAction(e: any) {
    console.log("\n ====================================================================================\n Action inited \n");
    console.log(e);

  }

  switchChangeAction(event: any) {
    console.log("switch changed value")
    console.log(event);

  }

  dataChange(e: any) {
    console.log("\n ================================== \n DataSource changed \n");
    console.log(e);
  }

  rowDataBound(e: any) {

  }


  btnClick(event: any) {
    if (event.action == 'modifica') {
      this.edit(event.data.nContratto, event.data.id)
    }
    if(event.action=='elimina'){
      this.deleteInit(event.data.id)
    }
  }

  setState(event: any) {
    let id = event.data.id;
    let state = !event.data.active;
    /*this.contrattiService.setState(id, state).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (response: boolean) => {
        console.log(response)
      },
      error: (error: any) => {
        console.log(error)
      }
    });*/
  }



  edit(codice: string, id: number): void {
    //this.contrattiService.setCurrentContrattoId(id);
    this.router.navigate([`/home/contratti/edit/${codice}`]);
  }

  deleteInit(id: number): void {

    this.idToRemove = id;
    this.dialog = DialogUtility.confirm({
      title: 'Conferma rimozione',
      content: 'Questa azione è irreversibile, vuoi procedere?',
      width: '50vh',
      position: { X: 'center', Y: 'center' },
      okButton: { click: this.deleteDialog.bind(this), text: 'si', cssClass: 'e-flat' },
      cancelButton: { text: 'no' },
    });
  }


  deleteDialog() {
    this.dialog.hide();
    this.delete();
  }

  delete() {

    /*this.contrattiService.delete(this.idToRemove).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (response: BaseResponse) => {
        this.toast.GenerateToast({
          title: '',
          content: response.error,
          severity: 'e-toast-success'
        });
        this.Cgrid?.refreshTable();

      },
      error: (response: BaseResponse) => {
        if (response.errorCode == 'FIELOK0011') {
          this.toast.GenerateToast({
            title: 'Campo in modifica',
            content: `${response.error} sta modificando questo campo, aspetta che finisca`,
            severity: 'e-toast-warning'
          });
        } else {
          this.toast.GenerateToast({
            title: '',
            content: response.error,
            severity: 'e-toast-danger'
          });
        }

      }
    })*/
  }

  add(): void {
    this.router.navigate(['/home/contratti/add']);

  }



}
